import type { Chat } from "schemas/generated/chat";

import React from "react";

import IconButton from "@replo/design-system/components/button/IconButton";
import { PanelLeft } from "lucide-react";

type Props = {
  chat: Chat | null | undefined;
  onToggleSidebar: () => void;
  isSidebarOpen: boolean;
  isGeneratingTitle: boolean;
};

const ChatHeader = React.memo(function ChatHeader({
  chat,
  onToggleSidebar,
  isSidebarOpen,
  isGeneratingTitle,
}: Props) {
  return (
    <div className="flex flex-row items-center gap-2 p-2 border-b-0.5 border-border w-full">
      <IconButton
        icon={<PanelLeft size={16} />}
        variant={isSidebarOpen ? "primary" : "secondary"}
        onClick={onToggleSidebar}
        tooltipText={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
      />
      {isGeneratingTitle ? (
        <div className="flex items-center gap-2 text-base font-medium">
          <span
            className="text-muted"
            style={{
              animation: "pulse 1.5s ease-in-out infinite",
            }}
          >
            Generating title...
          </span>
        </div>
      ) : (
        <div className="text-base font-semibold">
          {chat?.title ?? "Something New"}
        </div>
      )}
    </div>
  );
});

export default ChatHeader;
